// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { CustomAppState } from "@steiner/App/Store/Reducers";
import { VideoDocumentModel } from "@steiner/App/Store/Reducers/xProductDetails";
import { getSettingsCollection } from "@steiner/App/Store/Selectors/SettingsSelectors";
import { parseBoolean } from "@steiner/XDL/Utilities";

export function getProductVideos(state: CustomAppState, product: ProductModel, excludeYouTube = false): VideoDocumentModel[] | undefined {
    if (!product) {
        return undefined;
    }
    const customProductState = state.xProductDetails.byId[product.id];
    if (customProductState) {
        // Filter videos based on the excludeYouTube flag
        return excludeYouTube 
            ? customProductState.videos.filter(video => !parseBoolean(video.isYoutubeVideo)) 
            : customProductState.videos;
    }
    return undefined;
}

export function getSelectedVideoIndex(state: CustomAppState, product: ProductModel) {
    let selectedVideoIndex = -1;
    if (product) {
        const customProductState = state.xProductDetails.byId[product.id];
        if (customProductState) {
            selectedVideoIndex = customProductState.selectedVideoIndex;
        }
    }
    return selectedVideoIndex;
}

export function getSelectedVideo(state: CustomAppState, product: ProductModel): VideoDocumentModel | undefined {
    if (!product) {
        return undefined;
    }
    const customProductState = state.xProductDetails.byId[product.id];

    return customProductState && customProductState.selectedVideoIndex > -1
        ? customProductState.videos[customProductState.selectedVideoIndex]
        : undefined;
}

export const isNonStockProduct = (state: CustomAppState, productId: string | undefined) => {
    if (!productId) {
        return false;
    }

    const product = getProductState(state, productId);
    const nonStockProductId = getSettingsCollection(state).customSharedSettings.nonStockProductId;

    return product.id === nonStockProductId;
};

export const isNonStockProductProperty = (state: CustomAppState, productId: string | undefined) => {
    if (!productId) {
        return false;
    }

    const product = getProductState(state, productId);
    return product.value?.properties.itemStatus === "NONSTOCK";
};